import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadPropertyDocuments } from 'src/components/ui/UploadDocument';
import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';

interface Props {
  disabled?: boolean;
}

export const InvestmentBasicInformationUploader: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();

  return (
    <UploadPropertyDocuments
      disabled={disabled}
      showDivider={true}
      headline={t('dashboard.assets.addedit.investment.investmentterms.fields.investmentBasicInformation.label')}
      fileUrl={formik.values.documents?.investmentBasicInformation ?? ''}
      setFileUrl={(fileUrl) => formik.setFieldValue('documents.investmentBasicInformation', fileUrl)}
    />
  );
};
